import { TextInput, Textarea } from '@mint/ui';
import { AdminLinkedPage } from '../admin-linked-page';
import { AdminPanel } from '../admin-panel';
import { AdminPanelBody } from '../admin-panel-body';
import { AdminPanelHeader } from '../admin-panel-header';
import { AdminPanelHeading } from '../admin-panel-heading';
import { AdminPanelHeadingAction } from '../admin-panel-heading-action';
import { AdminPanelHeadingText } from '../admin-panel-heading-text';
import { AdminPanelMainForm } from '../admin-panel-main-form';
import { AdminPlacePanelActionButton } from './admin-place-panel-action-button';
import { AdminPlacePanelProps } from './admin-place-panel-props';
import { AdminPosterImageUploader } from '../admin-poster-image-uploader';
import PropTypes from 'prop-types';
import React from 'react';
import { useAdminPlacePanelController } from './use-admin-place-panel-controller';

export const AdminPlacePanel: React.FunctionComponent<AdminPlacePanelProps> = (
  props,
): React.ReactElement => {
  const {
    description,
    name,
    onDescriptionChange,
    onNameChange,
    onPageSelect,
    onPosterImageUploadStart,
    onTagsChange,
    pageTitle,
    posterImageKey,
    tags,

    onRegionChange,
    onPostalCodeChange,
    onLocalityChange,
    onStreetAddressChange,

    region,
    postalCode,
    locality,
    streetAddress,
  } = useAdminPlacePanelController(props.placeKey);

  return (
    <AdminPanel>
      <AdminPanelHeader>
        <AdminPanelHeading>
          <AdminPanelHeadingText>Place</AdminPanelHeadingText>
          <AdminPanelHeadingAction>
            <AdminPlacePanelActionButton placeKey={props.placeKey} />
          </AdminPanelHeadingAction>
        </AdminPanelHeading>
      </AdminPanelHeader>
      <AdminPanelBody>
        <AdminPanelMainForm>
          <TextInput
            onChange={onNameChange}
            value={name}
            label="Name"
            helperText="Place name."
          />
          <Textarea
            onChange={onDescriptionChange}
            label="Description"
            value={description}
            helperText="Description of the place."
          />
          <Textarea
            onChange={onTagsChange}
            label="Tags"
            value={tags}
            helperText="Place tags separated by spaces."
          />
          <AdminPosterImageUploader
            imageKey={posterImageKey}
            onUploadStart={onPosterImageUploadStart}
            helperText="This image is used on cards and for social media shares."
          />
          <AdminLinkedPage title={pageTitle} onPageSelect={onPageSelect} />
          <Textarea
            label="Street Address"
            onChange={onStreetAddressChange}
            value={streetAddress}
          />
          <div style={{ display: 'flex' }}>
            <div style={{ flex: 3 }}>
              <TextInput
                onChange={onLocalityChange}
                value={locality}
                label="City"
              />
            </div>
            <div style={{ flex: 1 }}>
              <TextInput
                onChange={onRegionChange}
                value={region}
                label="State"
                style={{ flex: 1 }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <TextInput
                onChange={onPostalCodeChange}
                value={postalCode}
                label="Zipcode"
                style={{ flex: 1 }}
              />
            </div>
          </div>
        </AdminPanelMainForm>
      </AdminPanelBody>
    </AdminPanel>
  );
};

AdminPlacePanel.propTypes = {
  placeKey: PropTypes.string.isRequired,
};
